var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45703_81864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 23,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16797 2.25H24.5893V25.5025H2.16797V2.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45703_81864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28122 3.9375C5.13522 3.9375 3.79297 5.598 3.79297 9.48712V18.261C3.79297 21.843 5.69747 23.8151 9.15547 23.8151H17.586C21.0353 23.8151 22.9344 21.843 22.9344 18.261V18.2576L22.9647 12.672C22.9647 8.84812 21.7016 7.3575 18.457 7.3575H15.3911C14.3631 7.35637 13.3816 6.84675 12.7641 5.994L11.775 4.62825C11.4641 4.19512 10.9668 3.93862 10.4468 3.9375H8.28122ZM17.586 25.5026H9.15547C4.84597 25.5026 2.16797 22.7273 2.16797 18.261V9.48712C2.16797 4.6845 4.22522 2.25 8.28122 2.25H10.4479C11.4781 2.25113 12.4596 2.76187 13.075 3.61575L14.0619 4.97925C14.375 5.41125 14.8722 5.66887 15.3922 5.67H18.457C22.6408 5.67 24.5897 7.89637 24.5897 12.6765L24.5594 18.2644C24.5583 22.7284 21.8868 25.5026 17.586 25.5026Z",
    fill: "#C6C6C8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1114 17.6758H8.64844C8.19994 17.6758 7.83594 17.2978 7.83594 16.832C7.83594 16.3663 8.19994 15.9883 8.64844 15.9883H18.1114C18.5599 15.9883 18.9239 16.3663 18.9239 16.832C18.9239 17.2978 18.5599 17.6758 18.1114 17.6758Z",
    fill: "#C6C6C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryGray);
export default __webpack_public_path__ + "static/media/category-gray.57183960214fdc872198905784ff2d71.svg";
export { ForwardRef as ReactComponent };